import { withApollo, graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import ForgotPassword from './index';

const changePasswordMutation = gql`
  mutation MyForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      message
    }
  }
`;

let RequestPasswordResetWithData = withApollo(
  compose(
    graphql(changePasswordMutation, {
      props({ ownProps, mutate }) {
        return {
          forgotPassword: email => {
            return mutate({
              variables: {
                email: email
              }
            });
          }
        };
      },
      options: {
        errorPolicy: 'all'
      }
    })
  )(ForgotPassword)
);

export default RequestPasswordResetWithData;



// WEBPACK FOOTER //
// ./src/components/RequestPasswordReset/RequestPasswordResetWithData.js